"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _admin = _interopRequireDefault(require("./admin"));
//
//
//
//
//
//
var _default = exports.default = {
  name: "Dashboard",
  components: {
    adminDashboard: _admin.default
  },
  data: function data() {
    return {
      currentRole: "adminDashboard"
    };
  }
};